import axios from 'axios';
import i18n from '../i18n';
import { formatNumber } from './localeFormat';

// Envanterdeki tarif defterini okur (POST /api/craft/book). Başarılıysa ekranda gösterilecek
// mesajı, değilse hatayı döner. Defterin seviyesi katalogda other.recipeBookLevel alanında.
export const readCraftRecipeBook = async (username, otherId) => {
  try {
    const res = await axios.post('/api/craft/book', { username, otherId: Number(otherId) });
    const data = res.data || {};
    if (data.success) {
      const recipe = data.recipe || {};
      const chance = i18n.t('craft:chance', { value: formatNumber(recipe.successRate, { maximumFractionDigits: 1 }) });
      return { ok: true, message: i18n.t('craft:learnedFromBook', { name: recipe.name, chance }), recipe };
    }
    return {
      ok: false,
      code: data.code,
      message: i18n.t(`craft:errors.${data.code || 'generic'}`, {
        defaultValue: data.message || i18n.t('craft:errors.generic'),
        level: data.unlockLevel ?? 1,
      }),
    };
  } catch (err) {
    return { ok: false, message: err.response?.data?.message || err.message || i18n.t('craft:errors.generic') };
  }
};
